// extracted by css-extract-rspack-plugin
export default {"card":"c0uhj8","header":"mUVAU_","iconBox":"HUO7EA"};